export enum InternationalRoutes {
  root = 'international',
  businessInfo = 'business-info',
  businessAddress = 'business-address',
  contactInfo = 'contact-info',
  finalDetails = 'final-details',
}
